import {
    BrowserRouter,
    Routes,
    Route
} from "react-router-dom";
import Login from "views/Login/Login";
import UsersPerRole from "views/UsersPerRole/UsersPerRole";
import Dashboard from "./Dashboard";
import Test from "../views/Test/Test";
import { IS_PRODUCTION } from "config/deploymentMode";

const MasterRouter = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="login" element={<Login />} />
                {!IS_PRODUCTION &&
                    <>
                        <Route path="usuarios-por-rol" element={<UsersPerRole />} />
                        <Route path="test" element={<Test />} />
                    </>}
                <Route path="*" element={<Dashboard />} />
            </Routes>
        </BrowserRouter>
    )
}

export default MasterRouter;